import { Button, notification } from "antd";
import { ReactComponent as IconBankBalanceAverage } from "../../../assets/images/BankBalanceAverage.svg";
import { ReactComponent as IconBankBalanceMaximum } from "../../../assets/images/BankBalanceMaximum.svg";
import { ReactComponent as IconBankBalanceMinimum } from "../../../assets/images/BankBalanceMinimum.svg";
import { ReactComponent as IconDownloadExcel } from "../../../assets/images/download_excel.svg";
import { ReactComponent as IconBackArrow } from "../../../assets/images/back_arrow.svg";
import BSAOutputDetailsChart from "./BSAOutputDetailsChart";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import "./BSAOutputDetails.scss";
import API_SERVICE from "shared/services/api-service";
import {
  numberWithCommas,
  saveByteArray,
} from "shared/services/Utility";
import AppLoading from "../AppLoading/AppLoading";

interface IBSAOutputDetails {
  showBSAOutputDetailsFor: string;
  setShowBSAOutputDetailsFor: Dispatch<SetStateAction<string>>;
  setBSASelectedTab: Dispatch<SetStateAction<"INPUT" | "OUTPUT" | undefined>>
}

const BSAOutputDetails: React.FC<IBSAOutputDetails> = (
  props: IBSAOutputDetails
) => {
  const { showBSAOutputDetailsFor, setShowBSAOutputDetailsFor, setBSASelectedTab } =
    props;

  const [loading, setLoading] = useState(false);
  const [outputOverview, setOutputOverview] = useState<any>();
  
  useEffect(() => {
    getBSAOutputDetail();
  }, []);

  const getBSAOutputDetail = () => {
    setLoading(true);
    API_SERVICE.getBSAOutputDetail(showBSAOutputDetailsFor)
      .then(({ data }) => {
        setOutputOverview(data?.payload);
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
        // setOutputOverview(tmpOutput);
      })
      .finally(() => setLoading(false));
  };

  const downloadBSAOutputExcel = (params: any, fileName: string) => {
    setLoading(true);
    API_SERVICE.downloadBSAOutputExcel(params)
      .then(({ data }) => {
        saveByteArray([data], fileName);
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <div className="balance-overview">
        <div className="balance-overview-header">
          <span>Balance Overview</span>
          <div style={{ display: "flex", gap: "10px" }}>
          {outputOverview?.bsaProvider != null && (
            <><Button
                className="app-btn-border"
                style={{ "--btnColor": "#20A74E" } as any}
                onClick={() => {
                  if (outputOverview?.bsaProvider == "FINBOX" && outputOverview.finboxOutputDocumentIds != null) {
                    outputOverview?.finboxOutputDocumentIds?.map((finboxOutputDocumentIds) => {
                      const params = { finboxOutputDocumentId: finboxOutputDocumentIds };
                      const fileName = finboxOutputDocumentIds ? `${finboxOutputDocumentIds}.xlsx` : "bsaOutput.xlsx";
                      downloadBSAOutputExcel(params, fileName);
                    });
                  } else {
                    const params = { filePath: outputOverview?.filePath };
                    const fileName = outputOverview?.filePath?.split("/")?.at(-1) ?? "bsaOutput.xlsx";
                    downloadBSAOutputExcel(params, fileName);
                  }
                } }
              >
                <IconDownloadExcel />
                Download
              </Button>
              </>
            )}
            <Button
                className="app-btn-border"
                style={{ "--btnColor": "#4285F4" } as any}
                onClick={() => {
                  setShowBSAOutputDetailsFor("");
                  setBSASelectedTab("OUTPUT");
                } }
              >
                  <IconBackArrow />
                  Back
                </Button>
          </div>
        </div>
        <div className="balance-overview-items">
          <div className="balance-overview-item">
            <IconBankBalanceAverage />
            <div className="boi-amount">
              <span className="boi-amount-title">Average Bank Balance</span>
              <span>
                Rs.{" "}
                {numberWithCommas(
                  outputOverview?.balanceOverview?.averageBankBalance
                )}
              </span>
            </div>
          </div>
          <div className="balance-overview-item">
            <IconBankBalanceMaximum />
            <div className="boi-amount">
              <span className="boi-amount-title">Maximum Bank Balance</span>
              <span>
                Rs.{" "}
                {numberWithCommas(
                  outputOverview?.balanceOverview?.maximumBankBalance
                )}
              </span>
            </div>
          </div>
          <div className="balance-overview-item">
            <IconBankBalanceMinimum />
            <div className="boi-amount">
              <span className="boi-amount-title">Minimum Bank Balance</span>
              <span>
                Rs.{" "}
                {numberWithCommas(
                  outputOverview?.balanceOverview?.minimumBankBalance
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        {Object.keys(outputOverview?.monthlyCreditDebitChart ?? {}).length >
          0 && (
          <BSAOutputDetailsChart
            monthlyCreditDebitChart={outputOverview?.monthlyCreditDebitChart}
          />
        )}
      </div>
      {loading && <AppLoading />}
    </div>
  );
};

export default BSAOutputDetails;
